export default function Quality() {
  let quality = (
    <>
      <div className={"content-wrapper"}>
        <div className={"content"}>
          <h1>Quality Statement</h1>
          <p className={"start-head"}>
            Our quality program, founded on
            <a href={"https://www.iso.org/iso-9001-quality-management.html"}>
              {" "}
              ISO9000 Standards
            </a>
            ,{" "}
            <a
              href={
                "http://everyspec.com/MIL-SPECS/MIL-SPECS-MIL-I/MIL-I-45208A_2885/"
              }
            >
              MIL-I-45208
            </a>
            ,{" "}
            <a
              href={
                "http://everyspec.com/MIL-STD/MIL-STD-2000-2999/MIL-STD-2000_10934/"
              }
            >
              MIL-2000
            </a>
            , and{" "}
            <a
              href={
                "https://www.ipc.org/ipc-610-acceptability-electronics-assemblies-endorsement-program"
              }
            >
              IPC-A-610
            </a>{" "}
            specifications, is consistently validated by positive customer
            feedback, industry awards, and consistently high acceptance rates.
            These results demonstrate that meticulous planning, rigorous
            testing, and exceptional workmanship are essential for producing
            high-quality products. We prioritize quality as a core value,
            integrating it into every stage of product development. We believe
            quality isn't achieved through final inspection, but rather built-in
            from the beginning. Contrax utilizes black box testing with GenRad
            in-circuit testing to consistently deliver zero-defect products to
            our customers. Our quality manual is available for customer review
            upon request. We value every customer as an integral part of our
            quality assurance process, and your continued satisfaction is our
            greatest measure of success. Our quality control team is adaptable
            and responsive to evolving client needs, employing advanced
            microscopic visual examination and thorough inspection of all items
            before shipment.{" "}
          </p>
        </div>
      </div>
      <div className={"bg-img"}>
        <img src="./Scripts/Assets/contrax_logo.svg" alt="" class="logo" />
      </div>
    </>
  );

  return quality;
}
